import AiGradient from "../../../images/Ai-Gradient-background.png"
const AiContent = ({ eyeBrowText = "AI Summary", description }) => {
  const bulletPoints = description
    .split('\n')
    .map(point => point.trim())
    .filter(point => point)
    .map(point => point.startsWith('- ') ? point.substring(2) : point);

  return (
    <div className="ai-content">
      <div className="ai-content__inner" style={{position:"relative"}}>
      <img src={AiGradient} className="img_gradient" alt="ai-gradient" style={{position:"absolute"}} />
       <div className="ai-content__content-list">
       <h3 className="ai-content__eyebrow">{eyeBrowText}</h3>
        <ul className="ai-content__list">
          {bulletPoints.map((point, index) => (
            <li key={index} className="ai-content__list-item">
              {point}
            </li>
          ))}
        </ul>
       </div>
      </div>
    </div>
  );
};

export default AiContent;